// hooks
import { useCommonMutation, useCommonQuery } from 'hooks';

// modules
import type { BaseApiResponse, ResultError } from 'modules';

// apis
import { AlarmAPI } from '../apis/alarm.api';

// keys
import { alarmKeys } from '../keys/alarm.key';
import { ReqCreateEnvAlarm } from '../models/create.model';
import { IAlarm, ReqAlarms, ResAlarms } from '../models/alarm.model';

const alarmApi = new AlarmAPI();

/** environment 웹 푸쉬 발생 쿼리 훅 */
export const useCreateEnvAlarm = () => {
  return useCommonMutation<BaseApiResponse<unknown>, ResultError, ReqCreateEnvAlarm>({
    mutationKey: alarmKeys.ALARM_ALL,
    mutationFn: async (data) => alarmApi.createEnvAlarm(data),
    queryKeyToInvalidate: alarmKeys.ALARM_ALL
  });
};

export const useFetchAlarms = ({ data }: { data: ReqAlarms }) => {
  return useCommonQuery<ReqAlarms, ResAlarms, ResultError, IAlarm[]>({
    data,
    queryKeyFactory: (data) => alarmKeys.FETCH_ALARMS(data),
    queryFn: (data, pagination) => {
      const request = {
        ...data,
        page: pagination.current,
        size: pagination.pageSize
      };

      return alarmApi.fetchAlarms(request);
    },
    options: {
      select: (data) => data.resultList
    }
  });
};

export const useFetchUnreadAlarmCount = ({ data }: { data: any }) => {
  return useCommonQuery<unknown, BaseApiResponse<number, unknown>, ResultError, number>({
    data,
    queryKeyFactory: () => alarmKeys.FETCH_UNREAD_ALARM_COUNT(),
    queryFn: async () => alarmApi.fetchUnreadAlarmCount(),
    options: {
      select: (data) => data.resultObject
    }
  });
};

export const useReadAlarm = () => {
  return useCommonMutation<BaseApiResponse, ResultError, string>({
    mutationKey: alarmKeys.CREATE_ALARM_READED(),
    mutationFn: (mappingId) => alarmApi.createAlarmReaded(mappingId),
    queryKeyToInvalidate: alarmKeys.ALARM_ALL
  });
};
